module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/icon_address-6e0f3f717bb8af3d4ba47a340d58ee29.svg";